import axios from "axios";
import { getAuth, signInWithCustomToken } from "firebase/auth";
import { getFirestore, doc, updateDoc } from "firebase/firestore";

export const createPaymentIntent = async ({ amount, currency }: any) => {
  try {
    const response = await axios.post(
      "https://us-central1-affekti---project.cloudfunctions.net/createPaymentIntent",
      { amount, currency },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.data) {
      throw new Error("No response data received from the server.");
    }

    return response.data;
  } catch (error) {
    console.error("Error creating Payment Intent:", error);
    throw error;
  }
};

export const createStripeAccount = async (userId: string, email: string) => {
  try {
    const response = await axios.post(
      "https://us-central1-affekti---project.cloudfunctions.net/createStripeAccount",
      { userId, email },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    console.log("Stripe Account Response:", response.data);
    window.location.href = response.data.onboardingUrl;
  } catch (error) {
    console.error("Error creating Stripe account:", error);
    throw error;
  }
};

export const retriveStripeAccount = async (stripeAccountId: string) => {
  try {
    const response = await axios.post(
      "https://us-central1-affekti---project.cloudfunctions.net/retriveStripeAccount",

      {
        stripeAccountId,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    console.log("Stripe Account Response:", response.data);

    // Redirect the user to the Stripe onboarding URL
    window.location.href = response.data.onboardingUrl;
  } catch (error) {
    console.error("Error creating Stripe account:", error);
    alert("Failed to create Stripe account. Please try again.");
  }
};

export const createPayout = async (userId: string, amount: number) => {
  try {
    const response = await axios.post(
      "https://us-central1-affekti---project.cloudfunctions.net/createPayout",
      // "http://127.0.0.1:5001/affekti---project/us-central1/createPayout",
      {
        userId,
        amount,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    console.log("Payout Response:", response.data);
    alert("Payout successfully created!");
  } catch (error) {
    console.error("Error creating payout:", error);
    alert("Failed to create payout. Please try again.");
  }
};

export const getStripeAccountDetails = async (stripeAccountId: string) => {
  try {
    const response = await axios.post(
      "https://us-central1-affekti---project.cloudfunctions.net/getStripeAccountDetails",
      { stripeAccountId },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error getting Stripe account details:", error);
    throw error;
  }
};

export const completeStripeOnboarding = async (
  userId: string,
  stripeAccountId: string
) => {
  try {
    const response = await axios.post(
      "https://us-central1-affekti---project.cloudfunctions.net/completeStripeOnboarding",
      { userId, stripeAccountId },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    // If we received a custom token, use it to authenticate and update the user document
    if (response.data.token) {
      const auth = getAuth();
      await signInWithCustomToken(auth, response.data.token);

      // Now update the user document directly from the client
      const db = getFirestore();
      const userRef = doc(db, "users", userId);
      await updateDoc(userRef, {
        stripeAccountId: stripeAccountId,
        stripeOnboardingComplete: true,
      });
    }

    return response.data;
  } catch (error) {
    console.error("Error completing Stripe onboarding:", error);
    throw error;
  }
};

export const getPayoutDetails = async (userId: string) => {
  try {
    const response = await axios.post(
      "https://us-central1-affekti---project.cloudfunctions.net/getPayoutDetails",
      { userId },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error getting payout details:", error);
    throw error;
  }
};
